module.exports = __webpack_public_path__ + "table_icon.svg?62f906eab3a25f93da24e505a18f3d81";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/table_icon.svg
// module id = 1066
// module chunks = 15